import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Loadding } from './components';
import * as serviceWorker from './serviceWorker';
import Loadable from 'react-loadable';
import { Login } from './pages';
import { checkToken } from './services/Login';

import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
const App = Loadable({ loader: () => import('./App'), loading: Loadding });
const AppSupplier = Loadable({ loader: () => import('./AppSupplier'), loading: Loadding });
const AppWms = Loadable({ loader: () => import('./AppWms'), loading: Loadding });

const logout = () => {
  window.localStorage.clear();
  window.sessionStorage.clear();
  window.location.href = 'http://auth.tmrmetal.com/auth/logout?redirect_uri=/';
}
const token = window.localStorage.getItem('token');
if (!token) {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <Route path="/login" component={Login}></Route>
        <Redirect
          to={{
            pathname: "/login",
            search: "?initUrl=/",
          }}
        />
      </Router>
    </React.StrictMode>,
    document.getElementById('root')
  );
} else {
  checkToken(token).then(data => {
    console.log('user,', data)
    if (data) {
      const user = data.user || {};
      const authorities = data.authorities || [];

      const userCategory = user.category_id;
      const alivable = [1, 2, 3, 4, 5];
      if (alivable.indexOf(userCategory) < 0) {
        ReactDOM.render(
          // <React.StrictMode>
          <div style={{ display: 'flex', padding: '1rem', alignItems: 'center', justifyContent: 'center' }}>
            <p style={{ textAlign: 'center', height: '90vh' }}>
              <h1>[{user.name}]未授权</h1>
              <h2>此用户没权限访问此系统，请联系管理员!</h2>
              <button onClick={logout}>切换用户</button>
            </p>
          </div>,
          //  </React.StrictMode>,
          document.getElementById('root')
        );
      } else {
        ReactDOM.render(
          //  <React.StrictMode>
          <div>
            {(userCategory === 1 || userCategory === 2) && <App user={user} authorities={authorities} />}
            {userCategory === 3 && <AppSupplier user={user} authorities={authorities} />}
            {userCategory === 4 && <AppWms user={user} authorities={authorities} />}
          </div>,
          //  </React.StrictMode>,
          document.getElementById('root')
        );
      }
    } else {
      ReactDOM.render(
        //  <React.StrictMode>
        <Router>
          <Route path="/login" component={Login}></Route>
          <Redirect
            to={{
              pathname: "/login",
              search: "?initUrl=/",
            }}
          />
        </Router>,
        // </React.StrictMode>,
        document.getElementById('root')
      );
    }
  })
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
